import { Directive, computed, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLinkActive } from '@angular/router';

import { SideMenuNestedItemHighlightViewModelEnum } from './side-menu-nested-item.view-model';

@Directive({
  selector: '[appSideMenuNestedItemLinkIsActive]',
})
export class SideMenuNestedItemLinkIsActiveDirective {
  readonly #routerLinkActive = inject(RouterLinkActive);

  public forcedHighlightState = input<SideMenuNestedItemHighlightViewModelEnum>();

  readonly #rlaIsActive = signal(false);

  constructor() {
    this.#routerLinkActive.isActiveChange.pipe(takeUntilDestroyed()).subscribe((isActive) => {
      this.#rlaIsActive.set(isActive);
    });
  }

  public isActive = computed(() => {
    const rlaIsActive = this.#rlaIsActive();
    const forcedHighlightState = this.forcedHighlightState();

    if (forcedHighlightState === SideMenuNestedItemHighlightViewModelEnum.Highlight) {
      return true;
    }

    if (forcedHighlightState === SideMenuNestedItemHighlightViewModelEnum.NoHighlight) {
      return false;
    }

    return rlaIsActive;
  });
}
